// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__GinD-","validationTips":"StatementDescriptor_validationTips__1cTFH"};